import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes, useNavigate } from 'react-router'

import { AppPath } from '../../../AppPath'
import { PolicyAdjustmentResultRouter } from '../adjustments'
import { ExcessPath } from './ExcessPath'

export const ExcessRouter: FunctionComponent = () => {
  const navigate = useNavigate()

  return (
    <Routes>
      <Route
        key='review'
        path={ExcessPath.REVIEW + AppPath.WILDCARD}
        element={
          <PolicyAdjustmentResultRouter
            onComplete={() => navigate('..')}
            onRepeat={() => navigate('..')}
          />
        }
      />
      <Route path='*' element={<Navigate to='../..' />} />
    </Routes>
  )
}
